import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RemoteEnvironment } from 'src/app/interfaces/remote-environment.interface';

@Injectable({
    providedIn: 'root',
})
export class RemoteConfigService {
    private config: RemoteEnvironment = {};
    private loaded = false;

    constructor(private http: HttpClient) { }

    /**
     * Busca as variáveis de ambiente remotas no endpoint `api/v1/environment`.
     * Deve ser chamado via APP_INITIALIZER para garantir que os dados estejam
     * disponíveis antes da renderização de qualquer componente.
     */
    load(): Promise<void> {
        return firstValueFrom(
            this.http.get<RemoteEnvironment>(`${environment.api}v1/environment/global`)
        )
            .then((data) => {
                this.config = data ?? {};
                this.loaded = true;
            })
            .catch((err) => {
                // Não bloqueamos o app caso o endpoint esteja indisponível.
                // Logue o erro e continue com um config vazio.
                console.error('[RemoteConfigService] Falha ao carregar configurações remotas:', err);
                this.config = {};
                this.loaded = false;
            });
    }

    /**
     * Retorna o valor de uma chave específica da configuração remota.
     *
     * @example
     * const modo = this.remoteConfig.get<boolean>('maintenance_mode');
     */
    get<T = unknown>(key: keyof RemoteEnvironment): T | undefined {
        return this.config[key] as T | undefined;
    }

    /**
     * Retorna uma cópia do objeto de configuração remota completo.
     */
    getAll(): RemoteEnvironment {
        return { ...this.config };
    }

    /**
     * Indica se o carregamento remoto foi concluído com sucesso.
     */
    isLoaded(): boolean {
        return this.loaded;
    }
}
